var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canSendForReview(_vm.account, _vm.schoolList))?_c('BaseFlow',{attrs:{"icon":"fas fa-undo-alt"},on:{"click":_vm.sendForReview}},[_vm._v(" Marquer comme révisée ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }